import {PageLink} from '../../_metronic/layout/core'
import Navigation from '../../components/Navigation/Navigation'
import CustomerReport from './layouts/CustomerReport'
import SalesRepReport from './layouts/SalesRepReport'
import SalesRepTypeReport from './layouts/SalesRepTypeReport'
import CouponCodeReport from './layouts/CouponCodeReport'

const CouponCodeReportPageCrumbs: Array<PageLink> = [
  {
    title: 'Analytics',
    path: '/analytics/profitability/profitability-report',
    isSeparator: false,
    isActive: true,
  },
  {
    title: 'Profitability',
    path: '/analytics/profitability/profitability-report',
    isSeparator: false,
    isActive: true,
  },
]

const CouponCodeReportPage = () => {
  return (
    <Navigation
      baseUrl='/analytics/profitability/coupon-code-report'
      breadcrumbs={CouponCodeReportPageCrumbs}
      pageTitle='Coupon Code Report'
      navigationData={[
        {
          key: 'customer-report',
          label: 'Customer',
          component: <CustomerReport />,
        },
        {
          key: 'sales-rep-report',
          label: 'Sales Representative',
          component: <SalesRepReport />,
        },
        {
          key: 'sales-rep-type-report',
          label: 'Sales Representative Type',
          component: <SalesRepTypeReport />,
        },
        {
          key: 'coupon-code-report',
          label: 'Coupon Code Report',
          component: <CouponCodeReport />,
        },
      ]}
    />
  )
}

export default CouponCodeReportPage
